import CheckBoxRadio from "../../CheckBoxRadio"
import { MdOutlineSentimentVeryDissatisfied } from "react-icons/md"
import Typography from "../../Typography"
import CircularProgress from "../../CircularProgress"
import IconNota from "../IconNota"
import ContextTela from "../../../pages/DicasOtimizacao/telaContext"
import { useContext } from "@wordpress/element"
import RadioGroupBase from "./RadioGroupBase"
import TooltipBase from "../TooltipBase"
import { IoMdCheckmark, IoMdClose } from "react-icons/io"

export default function RadioGroup({ valorInputRadio, setValorInputRadio, alerta = null, placeholder, opcoes, carregando = false, nota, children, group }) {
    const { mobile, desktop } = useContext(ContextTela)
    return (
        <div className={`${desktop ? "w-5/6" : "w-full"} justify-start items-start gap-3 inline-flex mt-4`} id={group}>
            <TooltipBase texto={
                    alerta ? alerta : <div className='flex flex-col '>
                      {nota?.criterios?.map((item, index) => (
                        <div key={index} className="flex flex-row items-center gap-2 ">
                          <div>
                            {item.otimizado ? <IoMdCheckmark className='w-4 h-4' /> : <IoMdClose className='w-4 h-4 pt-1' />}
                          </div>
                          <span>{item?.texto}</span>
                        </div>
                      ))
                      }
                    </div>
                  }
                    item={<IconNota nota={nota?.valor} alerta={alerta} />} />
            <RadioGroupBase
                valorInputRadio={valorInputRadio}
                setValorInputRadio={setValorInputRadio}
                placeholder={placeholder}
                opcoes={opcoes}
                carregando={carregando}
                nota={nota}
                group={group}>
                {children}
            </RadioGroupBase>
        </div>
    )
}